export const INSTALL_COUNT_DESC = 'INSTALL_COUNT_DESC';
export const REVIEW_COUNT_DESC = 'REVIEW_COUNT_DESC';
export const RATING_OVERALL_DESC = 'RATING_OVERALL_DESC';
export const RATING_EASE_OF_USE_DESC = 'RATING_EASE_OF_USE_DESC';
export const RATING_SUPPORT_DESC = 'RATING_SUPPORT_DESC';
export const RATING_VALUE_DESC = 'RATING_VALUE_DESC';
export const RATING_PERFORMANCE_DESC = 'RATING_PERFORMANCE_DESC';
export const NEWEST = 'NEWEST';
export const PRICE_DESC = 'PRICE_DESC';
export const PRICE_ASC = 'PRICE_ASC';